var indicative = require("indicative");
var moment = require('moment');

var Validate = (function() {

    var _splitName = function(fullName) {
        var names = fullName.split(" ");
        return {
            first: names.shift(),
            last: names.shift() || ""
        }
    };

    var date_of_birth = function(data, field, message, args) {
        var eighteenYearsAgo = moment().subtract(18, "years");
        var dob = moment(data.dob, 'l');

        return new Promise(function(resolve, reject) {
            if (dob.isValid() && eighteenYearsAgo.isAfter(dob)) {
                return resolve('is valid dob');
            } else {
                return reject(message);
            }
        });
    };

    var is_valid_postalCode = function(data, field, message, args) {
        return new Promise(function(resolve, reject) {
            if (/^\d{5}$/.test(data[field])) {
                return resolve('is valid ZIP Code');
            } else {
                return reject(message);
            }
        });
    };

    var _validate = function(firstName, lastName, gender, dob, postalCode) {
        var Indicative = new indicative();

        var rules = {
            first: 'required',
            last: 'required',
            gender: 'required',
            dob: 'required|dob',
            postalCode: 'required|postalCode'
        };

        var messages = {
            "first.required": "First name is required",
            "last.required": "Last name is required",
            "gender.required": "Gender is required",
            "dob.required": "Date of Birth is required",
            "dob.dob": "You must be 18 years or older to participate",
            "postalCode.required": "ZIP Code is required",
            "postalCode.postalCode": "A valid 5 digit ZIP Code is required"
        };

        var data = {
            first: firstName,
            last: lastName,
            gender: gender,
            dob: dob,
            postalCode: postalCode
        };

        Indicative.extend('dob', 'You must be 18 years or older to participate', date_of_birth);
        Indicative.extend('postalCode', 'A valid 5 digit ZIP Code is required', is_valid_postalCode);

        return Indicative
            .validateAll(rules, data, messages)
            .then(function(validation_passed) {
                return true;
            })
            .catch(function(error) {
                var errorMessage = '';
                for (var i = 0, errorLength = error.length; i < errorLength; i++) {
                    errorMessage += error[i].message + '\n';
                };
                return errorMessage;
            });
    };

    return {
        splitName: _splitName,
        validate: _validate
    };

})();

module.exports = Validate;



// WEBPACK FOOTER //
// ./src/common/modules/profile/profileUtils.js